import useI18n from "@/hooks/useI18n";
import { links } from "@/modules/environment";
import Invite from "@/ui/Invite";

export default function HotelInvite() {
  const { t } = useI18n();

  return (
    <Invite
      link={links.hotelInviteUrl}
      strings={{
        title: { success: t("hotels.invite.title") },
        subtitle: { success: t("hotels.invite.subtitle") },
        button: t("menu.sale")
      }}
    />
  );
}
